export default abstract class AbstractPlatformWindow {
    private focused: boolean = false;

    abstract resize(width: number, height: number, center: boolean, maximized: boolean): Promise<void>;

    abstract move(x: number, y: number): Promise<void>;

    abstract minimize(): Promise<void>;

    abstract getSize(): Promise<PlatformWindowGetSizeResponse>;

    isFocused(): boolean {
        return this.focused;
    }

    setIsFocused(value: boolean) {
        this.focused = value;
        return this;
    }

    isFocusAvailable() {
        return false;
    }

    public async center() {
        let size = await this.getSize();
        let x = (screen.availWidth - size.width) / 2;
        let y = (screen.availHeight - size.height) / 2;
        if (y < 0) {
            y = 0;
        }
        if (x < 0) {
            x = 0;
        }
        await this.move(Math.floor(x), Math.floor(y));
    }

    abstract setBadge(value?: number): void;

    abstract openDevTools(): Promise<void>;

    public focus() {

    }

    public setIcon(icon: string) {

    }
}

export interface PlatformWindowGetSizeResponse {
    width: number;
    height: number;
    maximized: boolean;
    minimized: boolean;
}